import { LimitedSchemaInfiniteQueryOptions } from '@frontend/react-query-helpers';
import { ListWorkspacesIO } from '../types';
import { useWorkspacesApiV1InfiniteQuery } from './use-workspaces-api-v1-infinite-query';

type ListWorkspacesPageParam = { pageToken?: string };

export const useListWorkspacesInfiniteQuery = <E = unknown, D = ListWorkspacesIO['output']>(
  orgId: string,
  options?: LimitedSchemaInfiniteQueryOptions<ListWorkspacesIO, E, D, any, ListWorkspacesPageParam>
) =>
  useWorkspacesApiV1InfiniteQuery<'ListWorkspaces', E, D, ListWorkspacesPageParam>({
    endpointName: 'ListWorkspaces',
    request: ({ pageParam }) => ({
      filter: `org_id="${orgId}"`,
      pageSize: 25,
      pageToken: pageParam?.pageToken,
    }),
    options: {
      enabled: !!orgId,
      getNextPageParam: (lastPage): ListWorkspacesPageParam | undefined =>
        lastPage.nextPageToken ? { pageToken: lastPage.nextPageToken } : undefined,
      ...options,
    },
  });
